/* Presentation adapter only. EasySell retains all offers, pricing and order logic. */
(() => {
  function setup(root) {
    if (root.dataset.yakootaBound) return;
    root.dataset.yakootaBound = 'true';
    let scheduled = false;
    const paint = () => {
      scheduled = false;
      const slot = root.querySelector('[data-yakoota-order]');
      const app = root.querySelector('#easysell');
      if (!slot || !app || !app.querySelector('#es-form')) return;
      if (app.parentElement !== slot) slot.appendChild(app);
      root.classList.add('yakoota-app-ready');
      const style = (selector, rules) => app.querySelectorAll(selector).forEach(el => {
        Object.entries(rules).forEach(([key, value]) => {
          if (el.style.getPropertyValue(key) !== value || el.style.getPropertyPriority(key) !== 'important') el.style.setProperty(key, value, 'important');
        });
      });
      style('#es-form-container', {'background':'transparent','border-radius':'0px','color':'#171417','font-family':'Geist, sans-serif'});
      style('.es-qo-container .mb-1, .es-o-p', {'font-size':'13px','font-weight':'600','color':'#171417'});
      style('.es-offer-badge, .es-badge', {'background':'#C93F74','color':'#ffffff','font-size':'9px','font-weight':'650','border-radius':'2px'});
      style('.es-input', {'background':'#ffffff','border-radius':'0px','color':'#171417'});
      style('#es-form-button', {'background':'#C93F74','color':'#ffffff','border-radius':'2px','border-color':'#C93F74','font-size':'14px','font-weight':'700'});

      if (!app.dataset.yakootaPurchasePolishBound) {
        app.dataset.yakootaPurchasePolishBound = 'true';
      }

      const handle = (() => {
        try {
          return new URL(root.dataset.url || location.href, location.origin).pathname.split('/').filter(Boolean).pop() || '';
        } catch (_) {
          return '';
        }
      })();

      app.classList.add('yakoota-easysell-polished');

      app.querySelectorAll('.es-qo-container').forEach((offer, index) => {
        offer.classList.add('yakoota-offer-card');
        offer.dataset.yakootaOfferIndex = String(index + 1);
      });

      // Add semantic hooks based on visible labels so the app can be styled consistently
      // without changing any form values, prices or submission logic.
      app.querySelectorAll('div, p, span, label').forEach((node) => {
        if (node.children.length) return;
        const label = (node.textContent || '').replace(/\s+/g, ' ').trim();
        if (!label) return;
        if (/^Total \(.*المجموع.*\)$/i.test(label) || /^Total$/i.test(label)) node.classList.add('yakoota-es-row-label');
        if (/^Livraison \(/i.test(label)) node.classList.add('yakoota-es-row-label');
        if (/Total à payer|المجموع النهائي/i.test(label)) node.classList.add('yakoota-es-total-label');
      });

      // Presentation-only correction for the Blush 2-item EasySell label.
      // Backend/order math is already 258 DH -> 199 DH = 59 DH; no pricing or submission logic is changed.
      if (handle === 'blush') {
        app.querySelectorAll('div, p, span, label').forEach((node) => {
          if (node.children.length) return;
          const label = (node.textContent || '').replace(/\s+/g, ' ').trim();
          if (!/Achetez\s+2\s+articles\s+et\s+économisez\s+79\s*(?:DH|MAD)/i.test(label)) return;
          node.dataset.yakootaBlushSavingCorrection = '59';
          node.textContent = label.replace(/79\s*(?:DH|MAD)/i, '59 DH');
        });
      }

      // Shorten only the visible product name inside the EasySell offer card.
      // The linked product/variant/order data is untouched.
      app.querySelectorAll('a').forEach((link) => {
        const href = link.getAttribute('href') || '';
        const label = (link.textContent || '').replace(/\s+/g, ' ').trim();
        if (handle === 'pack-duo-pour-le-visage' && /pack duo pour le visage/i.test(label)) {
          link.dataset.yakootaOriginalLabel = label;
          link.textContent = 'Pack Duo Visage';
          link.classList.add('yakoota-offer-title');
          if (!link.parentElement?.querySelector('.yakoota-offer-subtitle')) {
            const sub = document.createElement('span');
            sub.className = 'yakoota-offer-subtitle';
            sub.textContent = 'Sérum vitamine C + Crème hydratante';
            link.insertAdjacentElement('afterend', sub);
          }
        } else if (handle === 'blush' && /blush concentr/i.test(label)) {
          link.classList.add('yakoota-offer-title');
        }
      });

      app.querySelectorAll('button,input[type="button"],input[type="submit"]').forEach((secondaryButton) => {
        const secondaryLabel = ((secondaryButton.textContent || '') || (secondaryButton.value || '')).replace(/\s+/g,' ').trim();
        if (/^Appliquer$/i.test(secondaryLabel)) {
          secondaryButton.classList.add('yakoota-es-apply');
          secondaryButton.dataset.yakootaEsApplyBound = 'true';
        }
      });

      app.querySelectorAll('input').forEach((promoInput) => {
        const marker = ((promoInput.placeholder || '') + ' ' + (promoInput.name || '') + ' ' + (promoInput.id || '')).toLowerCase();
        if (!marker.includes('promo')) return;
        const scope = promoInput.parentElement;
        if (!scope) return;
        const promoButton = scope.querySelector('button,input[type="button"],input[type="submit"]');
        if (!promoButton || promoButton === promoInput) return;
        promoButton.classList.add('yakoota-es-apply');
        promoButton.dataset.yakootaEsApplyBound = 'true';
        if (promoButton.tagName === 'INPUT') {
          promoButton.value = 'Appliquer';
        } else if (!(promoButton.textContent || '').trim()) {
          promoButton.textContent = 'Appliquer';
        }
      });

      const existingReassurance = app.querySelector('.yakoota-easysell-reassurance');
      if (existingReassurance && existingReassurance.dataset.yakootaReassuranceVersion !== '2') {
        existingReassurance.remove();
      }

      const button = app.querySelector('#es-form-button');
      if (button && !app.querySelector('.yakoota-easysell-reassurance')) {
        const reassurance = document.createElement('div');
        reassurance.className = 'yakoota-easysell-reassurance';
        reassurance.dataset.yakootaReassuranceVersion = '2';
        reassurance.setAttribute('aria-label', 'Informations de paiement et livraison');
        const isPack = root.dataset.yakootaPack === 'true';
        reassurance.innerHTML = isPack
          ? '<div class="yakoota-reassurance-row"><strong>Paiement à la livraison</strong><small lang="ar" dir="rtl">كتخلصي ملي يوصلك الطلب</small></div><div class="yakoota-reassurance-row"><strong>Livraison sous 48h</strong><small lang="ar" dir="rtl">التوصيل فـ 48 ساعة</small></div><div class="yakoota-reassurance-row yakoota-reassurance-row--shipping"><strong>Livraison gratuite</strong><small lang="ar" dir="rtl">التوصيل مجاني مع هاد الباك</small></div>'
          : '<div class="yakoota-reassurance-row"><strong>Paiement à la livraison</strong><small lang="ar" dir="rtl">كتخلصي ملي يوصلك الطلب</small></div><div class="yakoota-reassurance-row"><strong>Livraison sous 48h</strong><small lang="ar" dir="rtl">التوصيل فـ 48 ساعة</small></div><div class="yakoota-reassurance-row yakoota-reassurance-row--shipping"><strong>1 produit : +15 DH · 2 produits ou + : livraison gratuite</strong><small lang="ar" dir="rtl">منتوج واحد 15 درهم · من جوج منتجات التوصيل مجاني</small></div>';
        button.insertAdjacentElement('afterend', reassurance);
      }
    };
    const observer = new MutationObserver(() => { if (!scheduled) { scheduled = true; requestAnimationFrame(paint); } });
    observer.observe(root, {childList:true, subtree:true});
    paint();
    document.addEventListener('shopify:section:unload', e => { if (e.target.contains(root)) observer.disconnect(); });
  }
  const init = () => document.querySelectorAll('.yakoota-product').forEach(setup);
  init();
  document.addEventListener('shopify:section:load', init);
})();

/* One mobile return-to-form control. Never submits or clones the EasySell form. */
(() => {
  const moneyLabel = value => {
    if (!value) return '';
    const numeric = Number(String(value).replace(',', '.'));
    if (!Number.isFinite(numeric)) return '';
    const clean = Number.isInteger(numeric) ? String(numeric) : numeric.toFixed(2).replace(/\.00$/, '');
    return clean + ' DH';
  };

  const extractPrices = text => {
    const values = [];
    const source = String(text || '');
    const patterns = [
      /(?:DH|MAD)\s*([0-9]+(?:[.,][0-9]{1,2})?)/gi,
      /([0-9]+(?:[.,][0-9]{1,2})?)\s*(?:DH|MAD)/gi
    ];
    patterns.forEach(pattern => {
      let match;
      while ((match = pattern.exec(source))) values.push(match[1]);
    });
    return values;
  };

  const init = () => document.querySelectorAll('.yakoota-product').forEach(root => {
    if (root.dataset.yakootaStickyBound) return;
    root.dataset.yakootaStickyBound = 'true';

    const mobile = matchMedia('(max-width: 749px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');

    const bar = document.createElement('div');
    bar.className = 'yakoota-sticky-purchase';
    bar.hidden = true;

    const meta = document.createElement('div');
    meta.className = 'yakoota-sticky-purchase__meta';

    const title = document.createElement('span');
    title.className = 'yakoota-sticky-purchase__title';
    title.textContent = root.querySelector('.product__title h1')?.textContent?.trim() || 'Produit Yakoota';

    const price = document.createElement('strong');
    price.className = 'yakoota-sticky-purchase__price';

    const shipping = document.createElement('small');
    shipping.className = 'yakoota-sticky-purchase__shipping';

    meta.append(title, price, shipping);

    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = 'COMMANDER · طلبي دابا';
    button.setAttribute('aria-label', 'Commander ce produit');

    bar.append(meta, button);
    document.body.append(bar);

    let main, frame = 0, returning = false, returnTimer;

    const editable = el => el instanceof Element && !!el.closest('input, textarea, select, [contenteditable="true"]');

    const visible = el => {
      if (!el || !el.isConnected || !el.getClientRects().length) return false;
      const r = el.getBoundingClientRect();
      const v = window.visualViewport;
      const top = v ? v.offsetTop : 0;
      const bottom = top + (v ? v.height : innerHeight);
      return r.width > 0 && r.height > 0 && r.bottom > top && r.top < bottom;
    };

    const fallbackPrice = () => {
      const el = root.querySelector('.price-item--sale, .price__sale .price-item--regular, .price-item--regular');
      const values = extractPrices(el?.textContent || '');
      return moneyLabel(values[values.length - 1]);
    };

    const syncOffer = () => {
      const app = root.querySelector('#easysell');
      const selected = app?.querySelector(
        '.es-qo-container[offer-selected="true"], .es-qo-container[offer-selected=true], .es-qo-container[aria-checked="true"], .es-qo-container.is-selected'
      );

      const offerText = selected?.innerText || selected?.textContent || '';
      const prices = extractPrices(offerText);
      const currentPrice = moneyLabel(prices[prices.length - 1]) || fallbackPrice();

      if (currentPrice && price.textContent !== currentPrice) price.textContent = currentPrice;

      const isPack = root.dataset.yakootaPack === 'true';
      const freeShipping = isPack || /livraison\s+(?:gratuite|offerte)|free\s+shipping/i.test(offerText);
      const shippingText = freeShipping ? 'Livraison gratuite · التوصيل مجاني' : '+15 DH livraison · التوصيل 15 درهم';
      if (shipping.textContent !== shippingText) shipping.textContent = shippingText;

      const aria = currentPrice
        ? `Commander — ${currentPrice}${freeShipping ? ', livraison gratuite' : ', plus 15 DH de livraison'}`
        : 'Commander ce produit';
      button.setAttribute('aria-label', aria);
    };

    const update = () => {
      frame = 0;
      const next = root.querySelector('#es-form-button');
      if (next !== main) {
        if (main) intersection.unobserve(main);
        main = next;
        if (main) intersection.observe(main);
      }

      syncOffer();

      const form = root.querySelector('form.es-form');
      const fieldsVisible = form && [...form.querySelectorAll('input:not([type="hidden"]), textarea, select')].some(visible);
      const keyboard = mobile.matches && visualViewport && innerHeight - visualViewport.height > 120;

      bar.hidden =
        !main ||
        !form ||
        main.disabled ||
        visible(main) ||
        fieldsVisible ||
        editable(document.activeElement) ||
        keyboard ||
        returning;
    };

    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    const intersection = new IntersectionObserver(schedule, {threshold:[0,1]});
    const mutations = new MutationObserver(schedule);
    mutations.observe(root, {childList:true, subtree:true, characterData:true, attributes:true});

    const finishReturn = () => {
      returning = false;
      schedule();
    };

    button.addEventListener('click', () => {
      const area = root.querySelector('[data-yakoota-order]');
      if (!area) return;
      returning = true;
      bar.hidden = true;
      area.setAttribute('tabindex','-1');
      area.focus({preventScroll:true});
      area.scrollIntoView({behavior:reduced.matches ? 'instant' : 'smooth', block:'start'});
      clearTimeout(returnTimer);
      returnTimer = setTimeout(finishReturn,1200);
    });

    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule);
    document.addEventListener('focusin',schedule);
    document.addEventListener('focusout',schedule);
    mobile.addEventListener('change',schedule);
    window.visualViewport?.addEventListener('resize',schedule);
    window.visualViewport?.addEventListener('scroll',schedule);

    const unload = event => {
      if (!event.target.contains(root)) return;
      intersection.disconnect();
      mutations.disconnect();
      cancelAnimationFrame(frame);
      clearTimeout(returnTimer);
      window.removeEventListener('scroll',schedule);
      window.removeEventListener('resize',schedule);
      document.removeEventListener('focusin',schedule);
      document.removeEventListener('focusout',schedule);
      mobile.removeEventListener('change',schedule);
      window.visualViewport?.removeEventListener('resize',schedule);
      window.visualViewport?.removeEventListener('scroll',schedule);
      bar.remove();
      delete root.dataset.yakootaStickyBound;
      document.removeEventListener('shopify:section:unload',unload);
    };

    document.addEventListener('shopify:section:unload',unload);
    schedule();
  });

  init();
  document.addEventListener('shopify:section:load',init);
})();

// Yakoota FAQ accordion
document.addEventListener('click',function(event){var button=event.target.closest('.yakoota-faq__question');if(!button)return;var item=button.closest('.yakoota-faq__item');var list=item&&item.parentElement;if(!item||!list)return;list.querySelectorAll('.yakoota-faq__question').forEach(function(other){if(other!==button){other.setAttribute('aria-expanded','false');var panel=document.getElementById(other.getAttribute('aria-controls'));if(panel)panel.hidden=true;var icon=other.querySelector('span:last-child');if(icon)icon.textContent='+';}});var panel=document.getElementById(button.getAttribute('aria-controls'));var open=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!open));if(panel)panel.hidden=open;var icon=button.querySelector('span:last-child');if(icon)icon.textContent=open?'+':'−';});













/* Yakoota unified 2-offer selector.
   The selector mirrors EasySell; it never creates or submits an order itself. */
(() => {
  const normalize = value => String(value || '').replace(/\s+/g, ' ').trim();

  const moneyValues = text => {
    const values = [];
    const source = normalize(text);
    const patterns = [
      /(?:DH|MAD)\s*([0-9]+(?:[.,][0-9]{1,2})?)/gi,
      /([0-9]+(?:[.,][0-9]{1,2})?)\s*(?:DH|MAD)/gi
    ];
    patterns.forEach(pattern => {
      let match;
      while ((match = pattern.exec(source))) values.push(Number(match[1].replace(',', '.')));
    });
    return values.filter(Number.isFinite);
  };

  const formatDh = value => {
    const n = Number(value);
    if (!Number.isFinite(n)) return '';
    return (Number.isInteger(n) ? String(n) : n.toFixed(2).replace(/\.00$/, '')) + ' DH';
  };

  const setup = root => {
    if (root.dataset.yakootaUnifiedOffersBound) return;
    root.dataset.yakootaUnifiedOffersBound = 'true';

    const slot = root.querySelector('[data-yakoota-order]');
    const grid = slot?.querySelector('[data-yakoota-choice-grid]');
    if (!slot || !grid) return;

    const isPack = root.dataset.yakootaPack === 'true';
    if (isPack) {
      root.classList.add('yakoota-unified-offers-ready');
      return;
    }

    const choice1 = grid.querySelector('[data-yakoota-choice="1"]');
    const choice2 = grid.querySelector('[data-yakoota-choice="2"]');
    if (!choice1 || !choice2) return;

    let scheduled = false;

    const setSelected = qty => {
      [choice1, choice2].forEach(card => {
        const active = Number(card.dataset.yakootaChoice) === qty;
        card.classList.toggle('is-selected', active);
        card.setAttribute('aria-pressed', String(active));
      });
    };

    const currentQty = app => {
      const selected = app.querySelector(
        '.es-qo-container[offer-selected="true"], .es-qo-container[offer-selected=true], .es-qo-container[aria-checked="true"], .es-qo-container.is-selected'
      );
      if (selected) {
        const offers = [...app.querySelectorAll('.es-qo-container')];
        const index = offers.indexOf(selected);
        if (index >= 0) return Math.min(index + 1, 2);
      }
      const input = app.querySelector('.quantity-picker-input');
      const value = Number(input?.value || 1);
      return value >= 2 ? 2 : 1;
    };

    const sync = () => {
      scheduled = false;
      const app = root.querySelector('#easysell');
      if (!app || !app.querySelector('#es-form')) return;

      const offers = [...app.querySelectorAll('.es-qo-container')];
      if (offers.length >= 2) {
        root.classList.add('yakoota-has-native-offers');

        const second = offers[1];
        if (second) {
          const text = normalize(second.innerText || second.textContent);
          const values = moneyValues(text);
          const price = values.length ? values[values.length - 1] : null;
          const priceEl = choice2.querySelector('[data-yakoota-choice-price="2"]');
          if (priceEl && price) priceEl.textContent = formatDh(price);

          const unitPriceCents = Number(slot.dataset.yakootaUnitPrice || 0);
          const unitPrice = Number.isFinite(unitPriceCents) ? unitPriceCents / 100 : 0;
          const realSaving = price != null && unitPrice > 0
            ? Math.max(0, (unitPrice * 2) - Number(price))
            : 0;

          // EasySell's visible "économisez" label can be stale or inconsistent with the
          // actual offer price. Keep EasySell's price/order logic, but present the saving
          // derived from the real unit price and the real 2-product offer price.
          second.querySelectorAll('div, p, span, label').forEach(node => {
            if (node.children.length || realSaving <= 0) return;
            const label = normalize(node.textContent);
            if (!/(?:économisez|economisez)\s*[0-9]+(?:[.,][0-9]{1,2})?\s*(?:DH|MAD)/i.test(label)) return;
            const corrected = label.replace(
              /((?:économisez|economisez)\s*)[0-9]+(?:[.,][0-9]{1,2})?\s*(?:DH|MAD)/i,
              '$1' + formatDh(realSaving)
            );
            if (corrected !== label) node.textContent = corrected;
          });

          const badge = choice2.querySelector('[data-yakoota-choice-badge]');
          if (badge) badge.textContent = realSaving > 0
            ? 'ÉCONOMISE ' + formatDh(realSaving)
            : 'LIVRAISON OFFERTE';

          const note = choice2.querySelector('[data-yakoota-choice-note]');
          if (note) note.innerHTML = 'Livraison gratuite · <span lang="ar" dir="rtl">التوصيل مجاني</span>';
        }
      } else {
        root.classList.remove('yakoota-has-native-offers');
      }

      setSelected(currentQty(app));
      root.classList.add('yakoota-unified-offers-ready');
    };

    const selectQuantity = qty => {
      const app = root.querySelector('#easysell');
      if (!app) return;

      const offers = [...app.querySelectorAll('.es-qo-container')];
      if (offers.length >= qty) {
        offers[qty - 1].click();
        setTimeout(sync, 80);
        return;
      }

      const input = app.querySelector('.quantity-picker-input');
      const plus = app.querySelector('.es-plus-button');
      const minus = app.querySelector('.es-minus-button');
      if (!input || !plus || !minus) return;

      let current = Number(input.value || 1);
      let guard = 0;
      while (current < qty && guard++ < 5) {
        plus.click();
        current += 1;
      }
      while (current > qty && guard++ < 10) {
        minus.click();
        current -= 1;
      }
      setTimeout(sync, 100);
    };

    choice1.addEventListener('click', () => selectQuantity(1));
    choice2.addEventListener('click', () => selectQuantity(2));

    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(sync);
    });
    observer.observe(root, {childList:true, subtree:true, attributes:true, characterData:true});
    sync();

    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) observer.disconnect();
    });
  };

  const init = () => document.querySelectorAll('.yakoota-product').forEach(setup);
  init();
  document.addEventListener('shopify:section:load', init);
})();
